/** @file shellBindings: the shell's key table in context `global` (undo, redo, screens, tools, menu openers). */
import type { Binding } from '@zilo/pose3d-shortcuts/types';

const g = (id: string, keys: string): Binding => ({ id, keys, context: 'global' });

/**
 * Every chord is an `event.code` chord; tools follow Unity (Q hand, W move, E rotate, R scale, T IK). Redo has two
 * chords under two ids (Mod+Shift+Z, Mod+Y) so Settings can rebind each; a held chord repeats (key auto-repeat).
 */
export const shellBindings: Binding[] = [
  g('history.undo', 'Mod+KeyZ'),
  g('history.redo', 'Mod+Shift+KeyZ'),
  g('history.redoAlt', 'Mod+KeyY'),
  g('app.settings', 'Mod+Comma'),
  g('app.escape', 'Escape'),
  g('menu.file', 'Alt+KeyF'),
  g('menu.edit', 'Alt+KeyE'),
  g('menu.view', 'Alt+KeyV'),
  g('menu.help', 'Alt+KeyH'),
  g('screen.pose', 'Digit1'),
  g('screen.art', 'Digit2'),
  g('screen.agent', 'Digit3'),
  g('tool.hand', 'KeyQ'),
  g('tool.move', 'KeyW'),
  g('tool.rotate', 'KeyE'),
  g('tool.scale', 'KeyR'),
  g('tool.ik', 'KeyT'),
  g('gizmo.space', 'KeyX'),
  g('gizmo.pivot', 'KeyZ'),
];
